











import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import Navbar from './adm/Navbar.vue'

@Component({ components: { Navbar } })
export default class Adm extends Vue {}
